import React from 'react'
import { TFunction, useTranslation } from 'react-i18next'
import IconBuybacks from '~/assets/images/buy-backs.svg'
import IconGovernance from '~/assets/images/governance.svg'
import IconMining from '~/assets/images/mining.svg'
import IconStaking from '~/assets/images/staking.svg'
import IconTreasury from '~/assets/images/treasury.svg'
import {
  StyledEconomicDetailItemWrapper,
  StyledEconomicWrapper,
} from './styled'
import { EconomicDetailItemProps } from './types'

const MAKE_ECONOMIC_DETAILS: (t: TFunction) => EconomicDetailItemProps[] = (
  t,
) => [
  {
    icon: IconBuybacks,
    title: t('economic_buy_back'),
    description: t('economic_buy_back_description'),
  },
  {
    icon: IconStaking,
    title: t('economic_staking'),
    description: t('economic_staking_description'),
  },
  {
    icon: IconMining,
    title: t('economic_mining'),
    description: t('economic_mining_description'),
  },
  {
    icon: IconTreasury,
    title: t('economic_treasury'),
    description: t('economic_treasury_description'),
  },
  {
    icon: IconGovernance,
    title: t('economic_governance'),
    description: t('economic_governance_description'),
  },
]

const EconomicDetailItem: React.FC<EconomicDetailItemProps> = ({
  icon,
  title,
  description,
}) => (
  <StyledEconomicDetailItemWrapper className="economic-detail-item-wrapper">
    <img className="economic-detail-img" src={icon} />
    <div className="economic-detail-info">
      <div className="economic-detail-info-title">{title}</div>
      <div className="economic-detail-info-description">{description}</div>
    </div>
  </StyledEconomicDetailItemWrapper>
)

export const EconomicMechanism: React.FC = () => {
  const { t } = useTranslation()
  const economicDetailItems = MAKE_ECONOMIC_DETAILS(t).map((props, index) => (
    <EconomicDetailItem {...props} key={index} />
  ))

  return (
    <StyledEconomicWrapper className="economic-mechanism-wrapper">
      <div className="economic-mechanism-title">{t('economic_mechanism')}</div>
      <div className="economic-mechanism-detail-wrapper">
        {economicDetailItems}
      </div>
    </StyledEconomicWrapper>
  )
}
